// src/charts/PercentageChangeChart.jsx
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const getHourColor = (hour) => {
  if ([0, 1, 2, 3, 4, 5].includes(hour)) return '#008550'; // Lav last
  if ([6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 21, 22, 23].includes(hour)) return '#EFB700'; // Høj last
  if ([17, 18, 19, 20].includes(hour)) return '#B71D13'; // Spids last
  return 'gray';
};

const PercentageChangeChart = ({ dataBefore, dataAfter, valueType,
  setValueType, percentChanges, yearBefore, yearAfter, monthFrom, monthTo }) => {
  const hours = Array.from({ length: 24 }, (_, i) => i);
const isProportion = valueType === 'averageHourlyProportionConsumption';

const yearMonthString = `${monthFrom.slice(0, 3)}-${monthTo.slice(0, 3)}`;
const title = isProportion
  ? `Andel af forbrug pr. time (${yearBefore} vs ${yearAfter}, ${yearMonthString})`
  : `Gennemsnitligt timeforbrug (${yearBefore} vs ${yearAfter}, ${yearMonthString})`;
const loadColor = (hour, year) => {
  if ([0,1,2,3,4,5].includes(hour)) return year === yearBefore ? '#00573d' : '#008550'; // Lav
  if ([6,7,8,9,10,11,12,13,14,15,16,21,22,23].includes(hour)) return year === yearBefore ? '#b48a00' : '#EFB700'; // Høj
  return year === yearBefore ? '#7a1111' : '#B71D13'; // Spids
};

const chartData = {
  labels: hours.map((h) => `${h}`),
  datasets: [
    {
      label: `${yearBefore}`,
      backgroundColor: hours.map(h => loadColor(h, yearBefore)),
      data: dataBefore,
    },
    {
      label: `${yearAfter}`,
      backgroundColor: hours.map(h => loadColor(h, yearAfter)),
      data: dataAfter,
    },
  ]
};



 const options = {
  responsive: true,
  plugins: {
    legend: {
    position: 'top',
    labels: {
      generateLabels: function(chart) {
        // const yearBefore = '2024';
        // const yearAfter = '2025';
        const items = [
          { text: `${yearBefore} Lav last`, fillStyle: '#00573d' },
          { text: `${yearAfter} Lav last`, fillStyle: '#008550' },
          { text: `${yearBefore} Høj last`, fillStyle: '#b48a00' },
          { text: `${yearAfter} Høj last`, fillStyle: '#EFB700' },
          { text: `${yearBefore} Spids last`, fillStyle: '#7a1111' },
          { text: `${yearAfter} Spids last`, fillStyle: '#B71D13' }
        ];

        return items.map((item, index) => ({
          text: item.text,
          fillStyle: item.fillStyle,
          strokeStyle: item.fillStyle,
          lineWidth: 1,
          hidden: false,
          index, // not tied to actual dataset
        }));
      }
    },
    onClick: null,
  },
    tooltip: {
  callbacks: {
    label: (ctx) => {
      const val = ctx.parsed.y * (isProportion ? 100 : 1);  // convert to percent
      const suffix = isProportion ? '%' : ' kWh';
      const significantDigits = isProportion ? 2 :0;
      return `${ctx.dataset.label}: ${val.toFixed(significantDigits)}${suffix}`;
    },
  },
    },
  },
  scales: {
    y: {
      title: {
        display: true,
        text: isProportion ? 'Andel af forbrug (%)' : 'Gns. timeforbrug (kWh)',
      },
      ticks: {
        callback: (value) =>
          isProportion ? `${(value*100).toFixed(2)}%` : `${value.toFixed(0)} kWh`,
      },
      beginAtZero: true,
    },
    x: {
      title: { display: true, text: 'Time på dagen' },
    },
  },
};


return (
  <Box sx={{ width: '100%' }}>
    <Box sx={{ width: 300, marginBottom: 0, marginTop: 2 }}>
      <FormControl fullWidth>
        <InputLabel id="value-type-label">Visning</InputLabel>
        <Select
          labelId="value-type-label"
          id="value-type"
          value={valueType}
          label="Visning"
          onChange={(e) => setValueType(e.target.value)}
        >
          <MenuItem value="averageHourlyProportionConsumption">
            Andel af forbrug (%)
          </MenuItem>
          <MenuItem value="averageHourlyTotalConsumption">
            Gns. forbrug (kWh/time)
          </MenuItem>
        </Select>
      </FormControl>
    </Box>

    <Box sx={{ width: '90%', margin: 'auto' }}>
      <Typography variant="h6" align="center" gutterBottom>
        {title}
      </Typography>
      <Bar data={chartData} options={options} />
    </Box>
  </Box>
);
};

export default PercentageChangeChart;
